/** @fileoverview Picks an icon for a document by its file extension. */

import { File, FileCode, FileJson, FileSpreadsheet, FileText } from 'lucide-react';

const SPREADSHEET = /\.(csv|tsv)$/i;
const CODE = /\.(html|htm)$/i;
const JSON_FILE = /\.json$/i;
const TEXT = /\.(pdf|txt|md|log)$/i;

/** Each type gets its own icon: a grid for CSV and TSV, code brackets for HTML, braces for JSON. */
export default function FileTypeIcon({ name, className }: { name: string; className?: string }) {
  if (SPREADSHEET.test(name)) return <FileSpreadsheet className={className} aria-hidden="true" />;
  if (CODE.test(name)) return <FileCode className={className} aria-hidden="true" />;
  if (JSON_FILE.test(name)) return <FileJson className={className} aria-hidden="true" />;
  if (TEXT.test(name)) return <FileText className={className} aria-hidden="true" />;
  return <File className={className} aria-hidden="true" />;
}
